export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11026.d3bd6301.jpg";